// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"263d7980","455":"09bf80ca","977":"5e0204c8"}[chunkId] + ".chunk.js";
};